import { BoothContract } from '@terra/shared-contracts-booth';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const boothClient = createTerraOrpcClient({
  contract: BoothContract,
  serviceName: SERVICE_NAME,
});
